import { TypeKeys } from '.';
import {
  getAssignment,
  subscribeToMemberAssignmentsUids,
} from '../components/sw-app/sw-portal/portal-firestore';
import { swApi } from '../global/app';

export interface GetUserAssignments {
  type: TypeKeys.GET_USER_ASSIGNMENTS;
  userAssignments: Assignment[];
}

export function getUserAssignments(assignments: Assignment[]) {
  const action: GetUserAssignments = {
    type: TypeKeys.GET_USER_ASSIGNMENTS,
    userAssignments: assignments,
  };
  return action;
}

export interface GetUserAssignmentData {
  type: TypeKeys.GET_USER_ASSIGNMENT_DATA;
  userAssignments: Assignment[];
}

export function getUserAssignmentData(
  assignments: Assignment[]
): GetUserAssignmentData {
  const action: GetUserAssignmentData = {
    type: TypeKeys.GET_USER_ASSIGNMENT_DATA,
    userAssignments: assignments,
  };
  return action;
}
export const setUserAssignments = () => async (dispatch, _getState) => {
  if (swApi.uid) {
    subscribeToMemberAssignmentsUids(swApi.uid, async (userAssignmentData) => {
      const membersAssignmentsData: Assignment[] = [];
      for (const assignment of userAssignmentData) {
        const assignmentData = await getAssignment(assignment.assignmentId);
        membersAssignmentsData.push({ ...assignment, ...assignmentData });
      }
      dispatch(getUserAssignmentData(membersAssignmentsData));
    });
  }
};
